<template>
  <main class="view documents">
    <div class="descriptor">
      <h1>{{ $t('documents.headline') }}</h1>
      <p>{{ $t('documents.copy') }}</p>
    </div>
    <div class="items">
      <a v-for="(item, idx) in items" :key="idx" :href="item.href" target="_blank">
        <div>
          <Icon name="chevronRight" class="chevron" />
          <Icon :name="item.type" class="filetype" />
          <span class="title">{{ item.label }}</span>
        </div>
        <span class="version">Version: {{ item.version }}</span>
      </a>
    </div>
  </main>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Resources',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      items() {
        return this.$t('documents.items');
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.documents {
  & > h1 {
    text-align: center;
    margin-bottom: 48px;
  }

  & > .items {
    position: relative;
    background-color: $color-white-solid-10;
    border-radius: $default-border-radius;
    width: 100%;
    filter: $box-shadow-2;
    margin: 0 auto 0 auto;
    padding: 32px;
    outline: 0;

    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      padding: 8px 12px;
      border-bottom: 1px solid $color-black-alpha-10;
      color: $color-blue-solid-100;
      text-decoration: none;

      &:last-of-type {
        margin-bottom: 0;
        border-bottom: 1px solid transparent;
      }

      & > div:first-of-type {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;

        & > svg.chevron {
          width: 16px;
          height: 16px;
          color: $color-black-alpha-40;
        }

        & > svg.filetype {
          width: 32px;
          height: 32px;
        }

        & > span.version {
          display: block;
        }
      }

      & > span.version {
        color: $color-black-alpha-80;
        font-size: 1.2rem;
      }

      &:hover {
        background-color: $color-black-alpha-05;

        & > div:first-of-type {
          & > svg.chevron {
            width: 16px;
            height: 16px;
            color: $color-black-alpha-80;
          }
        }
      }
    }
  }
}
</style>
